
import { EntityIdBase } from './EntityIdBase';

export class Sorteo extends EntityIdBase{
    Titulo: string = "";
    Numero: string = "";
    FechaCelebracion: Date = new Date();
}